const reasons = [
  {
    value: 'outlet',
    label: 'Вивід в Outlet',
    markColor: '#f39c12',
  },
  {
    value: 'offline',
    label: 'Тільки для offline продажу',
    markColor: '#3498db',
  },
  {
    value: 'temp',
    label: 'Тимчасово приховано',
    markColor: '#e74c3c',
  },
]

const getBrandsInactiveReasonOptions = () =>
  reasons.map(({ value, label }) => ({
    value,
    label,
  }))

export const fetchBrandInactiveReason = (value) =>
  reasons.find((reason) => reason.value === value) || {
    label: '',
    markColor: 'transparent',
  }

export default getBrandsInactiveReasonOptions
